const language = 'english'
export const langDir = 'ltr'

export default language
